import { render, staticRenderFns } from "./PacienteEstudios.vue?vue&type=template&id=bbeabf5c&scoped=true"
import script from "./PacienteEstudios.vue?vue&type=script&lang=js"
export * from "./PacienteEstudios.vue?vue&type=script&lang=js"
import style0 from "./PacienteEstudios.vue?vue&type=style&index=0&id=bbeabf5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeabf5c",
  null
  
)

export default component.exports